module.exports = __webpack_public_path__ + "img/Mercado-Pago-Logo.69319497.png";